import api from "./axios";

// Marketplace — public-side discovery + subscriptions.
// Phase 3 ships free subscriptions. Phase 5 swaps subscribeToPlan() for a
// Stripe Checkout redirect, but the shape of the call stays the same so
// callers don't need to change.

// GET /api/marketplace/advisors/  (AllowAny)
export const listMarketplaceAdvisors = async ({ jurisdiction } = {}) => {
  const params = {};
  if (jurisdiction) params.jurisdiction = jurisdiction;
  const res = await api.get("/api/marketplace/advisors/", { params });
  return res.data;
};

// GET /api/marketplace/advisors/<slug>/  (AllowAny)
export const getMarketplaceAdvisor = async (slug) => {
  const res = await api.get(`/api/marketplace/advisors/${slug}/`);
  return res.data; // { advisor, plans }
};

// POST /api/subscriptions/  (IsAuthenticated)
export const subscribeToPlan = async (planId) => {
  const res = await api.post("/api/subscriptions/", { plan_id: planId });
  return res.data;
};

// GET /api/subscriptions/  (IsAuthenticated)
export const listMySubscriptions = async () => {
  const res = await api.get("/api/subscriptions/");
  return res.data;
};

// DELETE /api/subscriptions/<id>/  (IsAuthenticated)
export const cancelSubscription = async (id) => {
  const res = await api.delete(`/api/subscriptions/${id}/`);
  return res.data;
};
